module.exports = __webpack_public_path__ + "static/media/info15_cambios_guardados_validacion_docs.75c3f790.png";